import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';
import linkstate from 'linkstate';
import md5 from 'crypto-js/md5';

import fields from '../../lib/fields';

import FormFields from '../../components/form/fields';
import ImageScroller from '../../components/imagescroller';
import HelpText from '../../components/gui/helpText';
import Input from '../../components/form/input';
import GuiList from '../../components/gui/list';
import UserProfileInline from '../../components/user/profileInline';
import Camera from '../../components/gui/camera';

import localUtil from '../../lib/util';
import { QRCodeSVG } from 'qrcode.react';

@withText(props => ({
    otpTitle: <Text id='input.otp-input'>Enter OTP</Text>,
}))
class ConventionViewSignup extends Component {
  	constructor(props) {
        super(props);
        this.state = {
        };
    }

    otpInput = e => {
        const userOtpIsValid = e.target.value.length === 6;
        this.setState({
            userOtp: e.target.value,
            userOtpIsValid,
        });
    }

    checkOtp = async e => {
        const { userOtp } = this.state;
        const { conventionStore } = this.props.stores;
        const { convention, jwtToken } = conventionStore;
        const response = await conventionStore.checkOtp(convention.uuidv4, userOtp);
        if (response.status === 200) {
            route(`/convention/${jwtToken}/signup`);
        } else {
            this.setState({
                userOtp: '',
                userOtpError: true,
            });
        }
    }

    closeDrawers = () => {
        const { appState } = this.props.stores;
        appState.toggleDrawer();
    }

    render() {
        const {
            userOtp,
            userOtpIsValid,
            userOtpError,
        } = this.state;
        const {
            otpTitle,
            isInTheFuture,
            isRegistrationOpen,
            signedUp,
            isConventionAdmin,
            countdown = {},
        } = this.props;
        const { appState, userStore, conventionStore, conventionResultStore } = this.props.stores;
        const { mainView, subView, isDevelopment, path } = appState;
        const { user = {}, isAdmin, isCustomerAdmin, isTester, isVeterinary, language, searchUsersResult } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        const { convention, jwtToken, otp = '' } = conventionStore;

        const otpFirstPart = otp.slice(0, 3);
        const otpSecondPart = otp.slice(3, 6);

        return (<>
            <div class={`d-flex flex-column justify-content-center align-items-center mt-3 mx-3 px-3 py-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                {convention.registrationIsOpen ? <>
                    {isInTheFuture && !signedUp ? <>
                        <h3 class='w-100 mb-2'><Text id='convention.registration-is-open'>Registration is open!</Text></h3>
                    </> : <></>}
                    {signedUp ? <></> : <>
                        <div class='w-100'>
                            <Text id='convention.not-signed-up'>You are not signed up for this convention. If you want to participate, please signup with the button below.</Text>
                        </div>
                        <a class='btn btn-block btn-primary btn-lg rounded-pill mt-3 mb-3' href={`/convention/${jwtToken}/signup`} onClick={this.closeDrawers}>
                            <Text id='convention.sign-up'>Sign up for convention</Text>
                        </a><br />

                        {isConventionAdmin ? <>
                            <div class='w-100 text-danger my-3'>
                                <i class='fa-regular fa-exclamation-triangle mr-2' />
                                <Text id='convention.is-admin-is-open-reg'>You are admin of this convention. Signup to this convention is open and does not require a code. If you want to participate you have to signup as well. All other admin functions are the same.</Text>
                            </div>
                        </> : <></>}
                    </>}
                </> : <>
                    {!user || !user.id ? <>
                        <div class='alert alert-danger rounded-lg d-flex flex-column align-items-center w-100' role='alert'>
                            <i class='fa-duotone fa-right-to-bracket mb-2' style='font-size: 3.0em;' />
                            <Text id='convention.must-login'>You must login to signup for this convention.</Text>
                        </div>
                        <a class='btn btn-primary btn-lg btn-block rounded-pill mt-2 mb-5' href='/login' onClick={this.closeDrawers}>
                            <i class='fa-duotone fa-right-to-bracket mr-2' /><Text id='convention.log-in'>Log in</Text>
                        </a>
                    </> : <>
                        {isConventionAdmin ? <>
                            {isRegistrationOpen ? <>
                                <QRCodeSVG value={`https://${window.location.hostname}/#/convention/${jwtToken}/signup`} size={256} />
                                <a href={`/convention/${jwtToken}/signup`} onClick={this.closeDrawers}><Text id='convention.sign-up-for-admin'>Sign up for admins!</Text></a><br />
                                <div
                                    class='d-flex text-center'
                                    style={`
                                        font-size: 2.5rem;
                                        font-weight: bold;
                                        letter-spacing: 10px;
                                        font-family: 'Courier New', Courier, monospace;
                                    `}
                                >
                                    {otpFirstPart} {otpSecondPart}
                                </div>
                            </> : <>
                                {isInTheFuture ? <>
                                    <div class='alert alert-success rounded-lg' role='alert'>
                                        <Text id='convention.is-admin'>You are admin of this convention. A QR-Code will appear here 1 hour before the start.</Text>
                                    </div>
                                </> : <></>}
                            </>}
                        </> : <>
                            {isRegistrationOpen ? <>
                                {!signedUp ? <>
                                    <div class='alert alert-danger rounded-lg d-flex flex-column align-items-center w-100' role='alert'>
                                        <i class='fa-duotone fa-user-magnifying-glass mb-2' style='font-size: 1.5em;' />
                                        <Text id='convention.not-admin'>Find an admin and ask for the QR-code to attend this convention.</Text>
                                    </div>

                                    {/* <Camera fps={5} stores={this.props.stores} /> */}

                                    <div class='d-flex flex-column justify-content-center  w-100 mt-4'>
                                        <Text id='convention.log-in-with-code'>Log in with code:</Text>

                                        <div class='input-group'>
                                            <div class='input-group-prepend'>
                                                <span class='input-group-text rounded-pill-left'>
                                                    <i class='fa-duotone fa-key'></i>
                                                </span>
                                            </div>
                                            <input
                                                class={`form-control form-control-lg rounded-pill-right`}
                                                type='text'
                                                value={userOtp}
                                                placeholder={`${otpTitle}`}
                                                onInput={this.otpInput}
                                                size='6'
                                                maxLength={6}
                                                // onBlur={this.clearSearch}
                                            />
                                        </div>
                                        {userOtpIsValid && <div class='d-flex flex-row justify-content-center mt-2'>
                                            <button
                                                // disabled={disabled}
                                                class={`btn btn-primary rounded-pill`}
                                                type='button'
                                                onClick={this.checkOtp}
                                            >
                                                <i class='fa-duotone fa-right-to-bracket' /> <span class=''><Text id='convention.login-with-code'>Login with code</Text></span>
                                            </button>
                                        </div>}

                                        {userOtpError ? <>
                                            <div class='alert alert-danger rounded-lg mt-2' role='alert'>
                                                <Text id='convention.wrong-code'>Wrong code!</Text>
                                            </div>
                                        </> : <></>}

                                    </div>

                                </> : <>
                                    <i class='fa-regular fa-face-smile text-success' style='font-size: 3.0em;' />
                                </>}
                            </> : <></>}
                        </>}
                    </>}
                </>}

                {isInTheFuture ? <>
                    {/* <Text id='convention.not-valid-date'>This convention is not active.</Text> */}
                    <div class='d-flex flex-column justify-content-center mt-2'>
                        <Text id='convention.starts-in'>Starts in:</Text>
                        <span class='display-4 text-monospace'>
                            {countdown && countdown.seconds >= 0 ? <>
                                {util.secToHms(countdown.seconds)}
                            </> : <></>}
                        </span>
                    </div>
                </> : <>
                    {!isRegistrationOpen ? <>
                        {convention.startDate ? <>
                            <div class='d-flex flex-column justify-content-center mt-0'>
                                <Text id='convention.has-been'>Has been:</Text>
                                <span class='text-monospace' style='font-size: 1.5em;'>
                                    {util.formatDate(convention.startDate, { hour12: false, hour: '2-digit', minute: '2-digit' })}
                                </span>
                            </div>
                        </> : <></>}
                    </> : <></>}
                </>}

                {signedUp ? <>
                    <div class='d-flex flex-row justify-content-center'>
                        <div class='text-success'>
                            <i class='fa-solid fa-check text-success' />
                            <small class='ml-2'>
                                {isInTheFuture || isRegistrationOpen ? <>
                                    <Text id='convention.signed-up'>You are signed up to this convention!</Text>
                                </> : <>
                                    <Text id='convention.signed-up-done'>You have attended this convention!</Text>
                                </>}
                            </small>
                        </div>
                    </div>
                    {isInTheFuture || isRegistrationOpen ? <>
                        <UserProfileInline stores={this.props.stores} showDone={true} />
                    </> : <></>}
                </> : <></>}

            </div>


            {/* {signedUp ? <>
                <div class={`d-flex flex-column mt-3 mx-3 px-3 py-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                    <div class='d-flex flex-row justify-content-center'>
                        <div class='text-success'>
                            <i class='fa-solid fa-check text-success' />
                            <span class='ml-2'>
                                {isInTheFuture || isRegistrationOpen ? <>
                                    <Text id='convention.signed-up'>You are signed up to this convention!</Text>
                                </> : <>
                                    <Text id='convention.signed-up-done'>You have attended this convention!</Text>
                                </>}
                            </span>
                        </div>
                    </div>
                    {isInTheFuture || isRegistrationOpen ? <>
                        <UserProfileInline stores={this.props.stores} showDone={true} />
                    </> : <></>}
                </div>
            </> : <></>} */}
        </>);
    }
}
export default ConventionViewSignup;
